import React from 'react';
import {CurrencyInputElementClass} from 'types/documentTemplateElement';
import {ElementProps} from 'types/documentTemplateElement';
import TextInput from '../../inputs/TextInput';
import CurrencyIcon from 'assets/images/icons/CurrencyIcon';
import {buildLabel, checkError} from 'utils/elementUtils';
import {useIsDocumentElementDisabled} from '../../../hooks/useIsDocumentElementDisabled';

const CurrencyInputElementComponent: React.FC<
  ElementProps<CurrencyInputElementClass>
> = ({element, updateElement, mode}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const onlyNumbers = e.target.value.replace(/\D/g, '');
    if (mode === 'view') {
      const newUpdatedElement = new CurrencyInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: onlyNumbers,
        },
      });
      updateElement(newUpdatedElement);
    }
    if (mode === 'admin') {
      const newUpdatedElement = new CurrencyInputElementClass({
        ...element,
        properties: {
          ...element.properties,
          value: onlyNumbers,
        },
      });
      updateElement(newUpdatedElement);
    }
    return;
  };

  const disabled = useIsDocumentElementDisabled(element, mode);

  let containerClass = 'w-full m-8';
  if (mode === 'view' || mode === 'preview' || mode === 'admin') {
    containerClass = element.properties.showLabel
      ? 'w-full mx-3 mb-2'
      : 'w-full mt-5 mx-3 mb-2';
  }

  return (
    <div className={containerClass}>
      <TextInput
        id={element.id}
        type="text"
        icon={<CurrencyIcon />}
        error={checkError(element, mode)}
        label={buildLabel(element)}
        value={element.properties?.value || ''}
        placeholder={element.properties.placeholder}
        required={element.properties.required}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
};

export default CurrencyInputElementComponent;
